/* eslint-disable typescript/ban-ts-comment */
// @ts-nocheck

import {useQuery} from "@apollo/client";

import {useFilteredRowSelection} from "@/components/table/hooks/useFilteredRowSelection.ts";
import {useTable} from "@/lib/hooks/useTable.ts";
import {GQL_MAINTENANCE_SCHEDULES_LIST, MaintenanceListResponse} from "@/lib/queries/maintenance.ts";
import {MaintenanceSchedulesControlBar} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/components/MaintenanceSchedulesControlBar.tsx";
import {TableBulkActionsBar} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/components/TableBulkActionsBar.tsx";
import {MaintenanceSchedulesTable} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/MaintenanceSchedulesTable.tsx";

const SESSION_STORAGE_FILTERS_KEY = "maintenance_list_filters";

export const MaintenanceSchedulesTab = () => {
  const {
    search,
    searchDebounced,
    searchChanged,
    pagination,
    setPagination,
    sorting,
    setSorting,
    sortingString,
    filterSets,
    setFilterSets,
  } = useTable({
    sessionStorageKey: SESSION_STORAGE_FILTERS_KEY,
    resetPaginationOnFilter: true,
    filtersKey: SESSION_STORAGE_FILTERS_KEY,
  });

  const {data, previousData, loading} = useQuery<MaintenanceListResponse>(GQL_MAINTENANCE_SCHEDULES_LIST, {
    variables: {
      ...pagination,
      sort: sortingString,
      search: searchDebounced,
      filters: filterSets,
    },
    pollInterval: 10000,
  });

  const responseData = data?.response || previousData?.response;
  const items = responseData?.items ?? [];

  const {rowSelection, setRowSelection} = useFilteredRowSelection({
    data: items,
    getRowId: (row) => String(row.id),
  });

  return (
    <>
      <MaintenanceSchedulesControlBar
        search={search}
        setSearch={searchChanged}
        filterSets={filterSets}
        onFilterSetChange={setFilterSets}
      />
      <MaintenanceSchedulesTable
        data={responseData}
        sortColumn={sorting.column}
        sortDirection={sorting.direction}
        onSortingChange={setSorting}
        pagination={pagination}
        setPagination={setPagination}
        isFiltered={!!searchDebounced || Object.keys(filterSets).length > 0}
        loading={loading}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
        actionBar={
          <TableBulkActionsBar schedules={items} selectedItems={rowSelection} setSelectedItems={setRowSelection} />
        }
      />
    </>
  );
};
